<template>
  <div>
  <navbar></navbar>
  <div class="app-body">
    <sidebar-menu :menu="menu" :collapsed="this.$store.state.sistema.collapsed " @collapse="onCollapse" :theme="selectedTheme" :showOneChild="false"  :width="width" :widthCollapsed="widthCollapsed" />
    <!-- Main content -->
    <div id="main" :class="[{'collapsed' : this.$store.state.sistema.collapsed }]">
      <div class="container-fluid">
        <router-view></router-view>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  import Navbar from '../layout/navbar'
  import Sidebar from '../layout/sidebar'
  export default {
    name: 'layout',
    components: {
      Navbar,
      Sidebar
    },
    data () {
      return {
        menu: [],
        collapsed: false,
        themes: ['', 'white-theme'],
        selectedTheme: 'white-theme',
        width: '280px',
        widthCollapsed: '60px'
      }
    },
    created: function () {
      this.criarMenu()
    },
    methods: {
      onCollapse (collapsed) {
        console.log(collapsed)
        this.$store.commit('SET_SISTEMA', collapsed)
      },
      onItemClick (event, item) {
        console.log('onItemClick')
        // console.log(event)
        // console.log(item)
      },
      criarMenu () {
        let menu_ = []
        if (this.$auth.check('P102')) {
          menu_.push({ href: '/grid', title: 'Grid', icon: 'icon-speedometer' })
        }
        if (this.$auth.check('P103')) {
          menu_.push({ href: '/dashboard', title: 'Dashboard', icon: 'icon-speedometer' })
        }
        if (this.$auth.check('P104')) {
          menu_.push({ href: '/monitoramento', title: 'Monitoramento', icon: 'icon-speedometer' })
        }
        if (this.$auth.check('P105')) {
          menu_.push({ href: '/relatorios', title: 'Relatórios', icon: 'icon-speedometer' })
        }
        if (this.$auth.check('P105')) {
          menu_.push({ href: '/relatoriosTelemetria', title: 'Relatórios Telemetria', icon: 'icon-speedometer' })
        }
        if (this.$auth.check('P107')) {
          menu_.push({ href: '/eventosDisparados', title: 'Eventos Disparados', icon: 'icon-speedometer' })
        }

        let menuChild = []
        // if (this.$auth.check('R204')) {
        menuChild.push({ href: '/analiseJornada', title: 'Análise', icon: 'icon-note' })
        menuChild.push({ href: '/gestaoJornada', title: 'Gestão Jornada', icon: 'icon-note' })
        menuChild.push({ href: '/analiseJornadaTabela', title: 'Análise Tabela', icon: 'icon-note' })
        // }
        if (this.$auth.check('P106')) {
          menu_.push({ title: 'Jornada', icon: 'icon-note', child: menuChild })
        }

        if (this.$auth.check('P110')) {
          let menuChildJC = []
          // if (this.$auth.check('R204')) {
          menuChildJC.push({ href: '/analiseJornadaConvencao', title: 'Análise Convenção', icon: 'icon-note' })
          menuChildJC.push({ href: '/gestaoJornadaConvencao', title: 'Gestão Jornada Convenção', icon: 'icon-note' })
          // }
          if (this.$auth.check('P106')) {
            menu_.push({ title: 'Jornada Convenção', icon: 'icon-note', child: menuChildJC })
          }
        }
        if (this.$auth.check('P118')) {
          let menuChildJC = []
          // if (this.$auth.check('R204')) {
          menuChildJC.push({ href: '/analiseJornadaTabela', title: 'Análise Tabela', icon: 'icon-note' })
          // menuChildJC.push({ href: '/gestaoJornadaConvencao', title: 'Gestão Jornada Convenção', icon: 'icon-note' })
          // }
          if (this.$auth.check('P118')) {
            menu_.push({ title: 'Jornada Tabela', icon: 'icon-note', child: menuChildJC })
          }
        }
        let menuChildC = []
        if (this.$auth.check('P110')) {
          menuChildC.push({ href: '/convencoes', title: 'Convenções', icon: 'icon-note' })
        }
        if (this.$auth.check('P110')) {
          menuChildC.push({ href: '/eventos', title: 'Eventos', icon: 'icon-note' })
        }
        // menuChildC.push({ href: '/areas', title: 'Áreas', icon: 'icon-note' })
        // menuChildC.push({ href: '/pontos', title: 'Pontos', icon: 'icon-note' })
        if (this.$auth.check('P113')) {
          menuChildC.push({ href: '/motoristas', title: 'Motoristas', icon: 'icon-note' })
        }
        if (this.$auth.check('P114')) {
          menuChildC.push({ href: '/veiculos', title: 'Veículos', icon: 'icon-note' })
        }
        if (this.$auth.check('P108')) {
          menu_.push({ title: 'Cadastros', icon: 'icon-note', child: menuChildC })
        }
        this.menu = menu_
      }
    }
  }
</script>
<style lang="css">
body,
html {
  margin: 0;
  padding: 0;
}
/* body {
  font-family: 'Source Sans Pro', sans-serif;
  background-color: #f2f4f7;
} */
#main {
  padding-left: 280px;
  width: 100%;
}
#main.collapsed {
  padding-left: 60px;
  width: 100%;
}
.demo {
  padding: 50px;
}
.badge-danger {
  background-color: #ff2a2a;
  color: #fff;
}
.v-sidebar-menu {
  position: fixed;
  top: 50px;
  left: 0;
  width: 100%;
  height: 95vh;
  padding-bottom: 25px;
  -webkit-transition: width .3s;
  transition: width .3s;
  z-index: 999;
}
.v-sidebar-menu .collapse-btn {
  display: none;
  text-align: center;
  font-style: normal;
  font-weight: 900;
  /* position: absolute; */
  height: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
  border: none;
  width: 0;
}
.v-sidebar-menu .vsm-link {
    position: relative;
    display: block;
    font-size: 14px;
    font-weight: 400;
    padding: 6px;
    line-height: 30px;
    text-decoration: none;
    z-index: 20;
    -webkit-transition: all .3s;
    transition: all .3s;
}
.v-sidebar-menu.white-theme .vsm-item.first-item>.vsm-link>.vsm-icon {
    color: #262626;
    background-color: transparent;
}
.v-sidebar-menu.white-theme .vsm-item.first-item.active-item>.vsm-link>.vsm-icon, .v-sidebar-menu.white-theme .vsm-item.first-item.parent-active-item>.vsm-link>.vsm-icon {
    color: #262626;
    background-color: transparent;
}
.v-sidebar-menu.white-theme .vsm-item.first-item.active-item>.vsm-link, .v-sidebar-menu.white-theme .vsm-item.first-item.parent-active-item>.vsm-link {
  color: #FFF;
  background-color: #20a8d8;
}
.v-sidebar-menu.white-theme.vsm-default .vsm-item.first-item.open-item>.vsm-link {
    color: #fff;
    background-color: #20a8d8;
}
.v-sidebar-menu.white-theme .vsm-dropdown>.vsm-list .vsm-link {
  color: #262626;
}
.v-sidebar-menu.white-theme.vsm-default .vsm-link:hover {
  color: #FFF;
  background-color: #20a8d8;
}
.v-sidebar-menu.white-theme.vsm-collapsed .vsm-link .active {
  color: #FFF;
  background-color: #20a8d8;
}
.v-sidebar-menu.white-theme.vsm-collapsed .vsm-link:hover {
  color: #FFF;
  background-color: #20a8d8;
}
.v-sidebar-menu.white-theme .vsm-dropdown>.vsm-list .vsm-link:hover {
  color: #FFF;
  background-color: #20a8d8;
}
.v-sidebar-menu.white-theme .vsm-dropdown>.vsm-list .active {
    color: #fff;
}
a.vsm-link.active {
  color: #fff;
  background-color: #20a8d8;
}
.v-sidebar-menu.white-theme .vsm-dropdown>.vsm-list {
    background-color: #FFF;
}
.v-sidebar-menu.white-theme .vsm-item.first-item.active-item>.vsm-link>.vsm-icon, .v-sidebar-menu.white-theme .vsm-item.first-item.parent-active-item>.vsm-link>.vsm-icon {
    color: #FFF;
    background-color: transparent;
}
.v-sidebar-menu .vsm-mobile-bg{background-color:#20a8d8}
.v-sidebar-menu.white-theme .vsm-mobile-bg{background-color:#20a8d8}
.vsm-item.first-item.parent-active-item>.vsm-link{-webkit-box-shadow:3px 0 0 0 #20a8d8 inset;box-shadow:inset 3px 0 0 0 #20a8d8}

.v-sidebar-menu .vsm-dropdown>.vsm-list {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 0;
  padding-right: 0;
}
.vsm-dropdown .vsm-list .vsm-item a {
  padding-left: 22px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/Index.vue